export enum AttributePropertyName {
  Recipient = 'Recipient',
  ShareRecipient = 'ShareRecipient',
}
